var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlerts({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Alerts, Warning, Signs Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 9C18.6213 9 19.125 9.50368 19.125 10.125V16.875H25.875C26.4963 16.875 27 17.3787 27 18C27 18.6213 26.4963 19.125 25.875 19.125H19.125V25.875C19.125 26.4963 18.6213 27 18 27C17.3787 27 16.875 26.4963 16.875 25.875V19.125H10.125C9.50368 19.125 9 18.6213 9 18C9 17.3787 9.50368 16.875 10.125 16.875H16.875V10.125C16.875 9.50368 17.3787 9 18 9Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerts);
export default __webpack_public_path__ + "static/media/Alerts.fa2d3ad5e95e354d0c76c694f4cd4e9b.svg";
export { ForwardRef as ReactComponent };